const entryPointMarker = Symbol('ENTRY-POINT-MARKER')

export default entryPointMarker
